import { useSyncExternalStore } from "react";
import { liveSocket, type ConnectionState } from "@/lib/live";

/**
 * The live socket's state, for the one thing that must always be on screen: whether what you
 * are looking at is still being updated. **W4.1.**
 *
 * Everything else in the app is a React Query cache, and a cache with no socket behind it
 * goes on rendering the last good answer indefinitely — a dead connection and a quiet market
 * look identical. §9's "never show stale data as live" is unenforceable without this being
 * visible somewhere, so it lives in the header strip that is on every screen.
 */
export function useConnectionState(): ConnectionState {
  return useSyncExternalStore(
    (onChange) => liveSocket.onConnectionChange(() => onChange()),
    () => liveSocket.connectionState,
  );
}
